// Microsoft Social Accounts' tenant
const MSA_TENANT_ID = '9188040d-6c67-4c5b-b112-36a304b66dad';
/** Returns true if a supplied MSAL account is a Microsoft Social Account
 *
 * @constant
 * @function
 * @param {Account} msal.AccountInfo
 * @returns {boolean}
 */
export const isMsalMsaAccount = (account) => (account === null || account === void 0 ? void 0 : account.tenantId) === MSA_TENANT_ID;
